<template>
    <div class="justifyContentBOX">
        <b-field class="commonrules-grp pb-4" label="Room rate is above the hotel's lowest rate by">
            <b-input type="number" v-model="obj.cost" @input="updatehotelCheapestRate" class="ml-2 nmbr-input"/>
            <b-select v-model="obj.unit" @input="changeUnits" >
                <option v-for="amountType in amountTypes" :key="amountType" :value="amountType">
                    {{ amountType }}
                </option>
            </b-select>
        </b-field>
    </div>
</template>
<script>

export default {
    name: "HotelCheapestRate",
    props: {
        rateOptions: null
    },
    data() {
        return {
            obj: {
                cost: '',
                unit: ''
            },
            amountTypes: ['percent', 'dollars'],
        }
    },
    methods: {
        updatehotelCheapestRate(val) {
            this.$emit('hotelCheapestRate', this.obj)
        },
        changeUnits(val) {
            this.$emit('hotelCheapestRate', this.obj)
        },
    },
    mounted() {
        this.obj.cost = this.rateOptions.amountVal;
        this.obj.unit = this.rateOptions.amountType;

    }
}
</script>
<style scoped>
.nmbr-input {
    width: 100%;
}
@media screen and (min-width: 768px) {
  .nmbr-input {
    width: 20%;
  }

}
</style>
